import { render } from "./AttorneySearch.vue?vue&type=template&id=d85a286e&scoped=true"
import script from "./AttorneySearch.vue?vue&type=script&lang=js"
export * from "./AttorneySearch.vue?vue&type=script&lang=js"

import "./AttorneySearch.vue?vue&type=style&index=0&id=d85a286e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85a286e"]])

export default __exports__